import styled from 'styled-components';

import { mediaQueryMobileMin } from 'styles';

const Wrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin: 0 -16px;
  padding: 0;
  padding-bottom: 16px;
  width: calc(100% + 32px);

  @media all and ${mediaQueryMobileMin} {
    margin: 0;
    padding: 16px 0;
    width: 100%;
  }
`;

export default Wrapper;
